export const REQUEST_ASSISTANCE = "@@ASSISTANCE/REQUEST_ASSISTANCE";
export const SUCCESS_ASSISTANCE = "@@ASSISTANCE/SUCCESS_ASSISTANCE";
export const FAILURE_ASSISTANCE = "@@ASSISTANCE/FAILURE_ASSISTANCE";

export const REQUEST_ASSISTANCES = "@@ASSISTANCES/REQUEST_ASSISTANCES";
export const SUCCESS_ASSISTANCES = "@@ASSISTANCES/SUCCESS_ASSISTANCES";
export const FAILURE_ASSISTANCES = "@@ASSISTANCES/FAILURE_ASSISTANCES";

export const REQUEST_CANCEL_ASSISTANCE =
  "@@CANCEL_ASSISTANCE/REQUEST_CANCEL_ASSISTANCE";
export const SUCCESS_CANCEL_ASSISTANCE =
  "@@CANCEL_ASSISTANCE/SUCCESS_CANCEL_ASSISTANCE";
export const FAILURE_CANCEL_ASSISTANCE =
  "@@CANCEL_ASSISTANCE/FAILURE_CANCEL_ASSISTANCE";

export const REQUEST_ASSISTANCE_STATUS =
  "@@ASSISTANCE_STATUS/REQUEST_ASSISTANCE_STATUS";
export const SUCCESS_ASSISTANCE_STATUS =
  "@@ASSISTANCE_STATUS/SUCCESS_ASSISTANCE_STATUS";
export const FAILURE_ASSISTANCE_STATUS =
  "@@ASSISTANCE_STATUS/FAILURE_ASSISTANCE_STATUS";

export const REQUEST_CURRENT_ASSISTANCE =
  "@@CURRENT_ASSISTANCE/REQUEST_CURRENT_ASSISTANCE";
export const SUCCESS_CURRENT_ASSISTANCE =
  "@@CURRENT_ASSISTANCE/SUCCESS_CURRENT_ASSISTANCE";
export const FAILURE_CURRENT_ASSISTANCE =
  "@@CURRENT_ASSISTANCE/FAILURE_CURRENT_ASSISTANCE";

export const UPDATE_ASSISTANCE_BODY = "@@ASSISTANCE/UPDATE_ASSISTANCE_BODY";
export const CLEAN_ASSISTANCE_BODY = "@@ASSISTANCE/CLEAN_ASSISTANCE_BODY";

export default (state: any, action: any) => {
  switch (action.type) {
    case REQUEST_ASSISTANCES:
      return {
        ...state,
        loading: true,
        assistances: [],
      };

    case SUCCESS_ASSISTANCES:
      return {
        ...state,
        assistances: action.payload,
        loading: false,
      };

    case FAILURE_ASSISTANCES:
      return {
        ...state,
        assistances: [],
        loading: false,
      };

    case REQUEST_ASSISTANCE:
      return {
        ...state,
        loading: true,
        errors: {},
        success: {},
      };

    case SUCCESS_ASSISTANCE:
      return {
        ...state,
        errors: {},
        success: {
          assistance: action.payload,
        },
        assistance_body: {},
        loading: false,
      };

    case FAILURE_ASSISTANCE:
      return {
        ...state,
        errors: {
          assistance: action.payload,
        },
        success: {},
        loading: false,
      };

    case REQUEST_CANCEL_ASSISTANCE:
      return {
        ...state,
        loading: true,
        errors: {},
        success: {},
      };

    case SUCCESS_CANCEL_ASSISTANCE:
      return {
        ...state,
        errors: {},
        success: {
          cancel_assistance: action.payload,
        },
        loading: false,
      };

    case FAILURE_CANCEL_ASSISTANCE:
      return {
        ...state,
        errors: {
          cancel_assistance: action.payload,
        },
        success: {},
        loading: false,
      };

    case REQUEST_CURRENT_ASSISTANCE:
    case REQUEST_ASSISTANCE_STATUS:
      return {
        ...state,
        // loading: true,
        errors: {},
        success: {},
      };

    case SUCCESS_CURRENT_ASSISTANCE:
    case SUCCESS_ASSISTANCE_STATUS:
      return {
        ...state,
        errors: {},
        success: {
          assistance_status: action.payload,
        },
        // loading: false,
      };

    case FAILURE_CURRENT_ASSISTANCE:
    case FAILURE_ASSISTANCE_STATUS:
      return {
        ...state,
        errors: {
          assistance_status: action.payload,
        },
        success: {},
        // loading: false,
      };

    case UPDATE_ASSISTANCE_BODY:
      return {
        ...state,
        assistance_body: {
          ...state.assistance_body,
          ...action.payload,
        },
      };

    case CLEAN_ASSISTANCE_BODY:
      return {
        ...state,
        assistance_body: {},
      };

    default:
      return state;
  }
};
